import React from 'react';
import { Check, X } from 'lucide-react';
export function Comparison() {
  return <section className="py-20 bg-stone-900 text-white" data-id="element-33">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-34">
        <div className="text-center mb-16" data-id="element-35">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white" data-id="element-36">
            Why This Is Different
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-37">
          {/* The "NO" Column */}
          <div className="bg-stone-800/50 rounded-2xl p-8 border border-stone-700" data-id="element-38">
            <h3 className="text-xl font-bold text-red-400 mb-6 uppercase tracking-wider" data-id="element-39">
              What We Avoid
            </h3>
            <ul className="space-y-6" data-id="element-40">
              <li className="flex items-start" data-id="element-41">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-red-500/20 flex items-center justify-center mt-0.5" data-id="element-42">
                  <X className="w-5 h-5 text-red-400" data-id="element-43" />
                </div>
                <span className="ml-4 text-lg text-stone-300" data-id="element-44">
                  <strong className="text-white" data-id="element-45">NO</strong> intense cardio that
                  destroys your joints.
                </span>
              </li>
              <li className="flex items-start" data-id="element-46">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-red-500/20 flex items-center justify-center mt-0.5" data-id="element-47">
                  <X className="w-5 h-5 text-red-400" data-id="element-48" />
                </div>
                <span className="ml-4 text-lg text-stone-300" data-id="element-49">
                  <strong className="text-white" data-id="element-50">NO</strong> expensive
                  supplements or hard-to-find ingredients.
                </span>
              </li>
              <li className="flex items-start" data-id="element-51">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-red-500/20 flex items-center justify-center mt-0.5" data-id="element-52">
                  <X className="w-5 h-5 text-red-400" data-id="element-53" />
                </div>
                <span className="ml-4 text-lg text-stone-300" data-id="element-54">
                  <strong className="text-white" data-id="element-55">NO</strong> monthly
                  subscriptions.
                </span>
              </li>
            </ul>
          </div>

          {/* The "YES" Column */}
          <div className="bg-amber-900/20 rounded-2xl p-8 border border-amber-500/30 relative overflow-hidden" data-id="element-56">
            <div className="absolute top-0 right-0 w-32 h-32 bg-amber-500/10 rounded-full blur-3xl -mr-16 -mt-16" data-id="element-57"></div>

            <h3 className="text-xl font-bold text-amber-400 mb-6 uppercase tracking-wider" data-id="element-58">
              What You Get
            </h3>
            <ul className="space-y-6 relative z-10" data-id="element-59">
              <li className="flex items-start" data-id="element-60">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-green-500/20 flex items-center justify-center mt-0.5" data-id="element-61">
                  <Check className="w-5 h-5 text-green-400" data-id="element-62" />
                </div>
                <span className="ml-4 text-lg text-stone-100" data-id="element-63">
                  <strong className="text-white" data-id="element-64">YES:</strong> 100% Natural
                </span>
              </li>
              <li className="flex items-start" data-id="element-65">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-green-500/20 flex items-center justify-center mt-0.5" data-id="element-66">
                  <Check className="w-5 h-5 text-green-400" data-id="element-67" />
                </div>
                <span className="ml-4 text-lg text-stone-100" data-id="element-68">
                  <strong className="text-white" data-id="element-69">YES:</strong> Science-backed
                </span>
              </li>
              <li className="flex items-start" data-id="element-70">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-green-500/20 flex items-center justify-center mt-0.5" data-id="element-71">
                  <Check className="w-5 h-5 text-green-400" data-id="element-72" />
                </div>
                <span className="ml-4 text-lg text-stone-100" data-id="element-73">
                  <strong className="text-white" data-id="element-74">YES:</strong> Ancestral-proven
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}